import React from 'react';
import SellingPlan from '../models/SellingPlan'

const SellingPlansContext = React.createContext();

const SellingPlansProvider = (props) => {
  const sellingPlans = (props && props.value || []).map((o) => SellingPlan(o))

  return (
    <SellingPlansContext.Provider value={sellingPlans}>
      {props.children}
    </SellingPlansContext.Provider>
  );
};

export { SellingPlansContext, SellingPlansProvider}
